module.exports = __webpack_public_path__ + "static/media/teacher18.7e59b909.png";